export const formatUrlTrailing = (url: string) => (url.match(/\/$/) ? url : url + '/');

// history v4 runs decodeURI on the pathname when it is pushed and again when the address bar is reloaded, so a
// route param holding a "%" is decoded more than once. Use "~" as the escape character instead: the encoded
// param has no "%", so the router leaves it alone and it survives clicks, reloads and shared links.
export const encodeRouteParam = (value: string): string =>
	encodeURIComponent(value).replace(/~/g, '%7E').replace(/%/g, '~');

// A malformed escape (e.g. a hand-typed "~ZZ") falls back to the raw value.
export const decodeRouteParam = (value: string): string => {
	try {
		return decodeURIComponent(value.replace(/~/g, '%'));
	} catch {
		return value;
	}
};
